import React from 'react'
import { useModel } from '@morningtrain/react-resources'
import { useConstrainable } from '@morningtrain/react-filters'
import { useRouter } from '@morningtrain/react-navigation'

function ConstrainScheduleToRoute (props) {
  const hasConstrainedRef = React.useRef(false)

  const model = useModel()
  const router = useRouter()
  const constrainable = useConstrainable()

  React.useEffect(() => {
    const disposer = constrainable.onResolve((constraints) => {
      return new Promise(resolve => {
        const scheduleId = model.get('id')
        const scheduleIdFromRoute = router.parameter('schedule')

        const shouldConstrainToId = (!!scheduleIdFromRoute) &&
          (parseInt(scheduleId) !== parseInt(scheduleIdFromRoute))

        if (shouldConstrainToId) {
          hasConstrainedRef.current = true
          constraints.schedule = scheduleIdFromRoute
        } else {
          if (typeof constraints.schedule !== 'undefined') {
            delete constraints.schedule
          }
        }

        resolve(constraints)
      })
    })

    return () => {
      disposer()
    }
  }, [])

  return null
}

export default ConstrainScheduleToRoute
